import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationDetails, CognitoUser, CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js';
import * as AWS from 'aws-sdk/global';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { TenantService } from './tenant.service';

@Injectable()
export class AuthService {

  private accessTokenVal: string = '';
  public $userloggedIn: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private userDetails: CognitoUser;
  private CogUserPool: CognitoUserPool;

  paused$ = new BehaviorSubject(false);
  public credentials$ = new BehaviorSubject(null);


  constructor(public http: HttpClient, public router: Router, private tenantService: TenantService) { }

  getCogUserPool(){
  this.CogUserPool = new CognitoUserPool({
    UserPoolId: this.tenantService.getParameter("cognito", "userPoolId"),
    ClientId: this.tenantService.getParameter("cognito", "clientId"),
  });
  }

  public getApiKey() {
    return this.tenantService.getParameter("sorrento", "apiKey")
  }

  public authenticateCongnito(data): Observable<any> {
    if(!this.CogUserPool){
      this.getCogUserPool();
    }
    const authResult = new Subject<any>();
    const CogAuthData = new AuthenticationDetails(data);
    const CogUser = new CognitoUser({
      Username: data.Username,
      Pool: this.CogUserPool
    });

    CogUser.authenticateUser(CogAuthData, {
      onSuccess: result => {
        authResult.next(result);
      },
      onFailure: err => {
        authResult.error(err);
      },
    });

    return authResult.asObservable();
  }

  public getCognitoCurrentUser() {
    if(!this.CogUserPool){
      this.getCogUserPool();
    }
    const currentUser: CognitoUser = this.CogUserPool.getCurrentUser();
    if (currentUser != null) {
      currentUser.getSession((err: Error, session: CognitoUserSession) => {
        if (session && session.isValid()) {
          this.$userloggedIn.next(true);
        }
      });
      this.UserDetails = {
        username: currentUser['username'],
      };
    }
  }

  public signOut() {
    if(!this.CogUserPool){
      this.getCogUserPool();
    }
    const currentUser = this.CogUserPool.getCurrentUser();
    if (currentUser) {
      currentUser.signOut();
      this.$userloggedIn.next(false);
      this.router.navigate(['login']);
    }
  }

  refreshCredentials() {

    return new Promise((resolve, reject) => {
      (<AWS.CognitoIdentityCredentials>AWS.config.credentials).refresh((error) => {
        if (error) {
          // rejects promise with error message
        } else {
          resolve(AWS.config.credentials);
          this.credentials$.next(AWS.config.credentials);
        }
      });

    });
  }

  getCredentials() {
    if (this.credentials$.getValue() == null) {
      return this.getCognitoCredentials();
    } else {
      return Promise.resolve(this.credentials$.getValue());
    }

  }
  async getCognitoCredentials() {
    let idPool = this.tenantService.getParameter("cognito", "identityPoolId")
    AWS.config.region = this.tenantService.getParameter("cognito", "region");

    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: idPool, // your identity pool id here
      Logins: {
      }
    });
    return await this.refreshCredentials().then(data => { return data });

  }

  set accessToken(value: string) {
    this.accessTokenVal = value;
  }

  get accessToken() {
    return this.accessTokenVal;
  }

  set UserDetails(value: any) {
    this.userDetails = value;
  }

  get UserDetails(): any {
    return this.userDetails;
  }

}
